import { useContext } from "react";
import { StateContext } from "../Board/StateContext";

export function useBoardID() {
  return useContext(StateContext).boardID;
}
